<template>
  <div class="rounded-lg bg-yellow-100 p-4" :class="classes">
    <span class="mb-1 block text-[15px] font-semibold text-black-100">{{
      title
    }}</span>
    <ul class="grid list-disc gap-1 pl-4 text-[14px] font-medium text-black-60">
      <li v-for="(item, index) in list" :key="index" v-html="item" />
    </ul>
  </div>
</template>

<script>
export default {
  name: "Notes",
  props: {
    title: {
      type: String,
      default: "Notes:",
    },
    list: {
      type: Array,
      default: () => [],
    },
    classes: {
      type: String,
      default: "",
    },
  },
};
</script>
